import './index.css'
const Secimage = () => {
    
    return (
        
        <div className="secimage">
            
            
            
        </div>
)
    
    
}

export default Secimage